"use client";
//#region packages/@mantine/core/src/components/Text/Text.module.css
var Text_module_default = { "root": "m_b6d8b162" };
//#endregion
export { Text_module_default as default };

//# sourceMappingURL=Text.module.mjs.map